export default __webpack_public_path__ + "static/media/czi.03cd430d.svg";